import { Input } from "antd";
import styles from "./styles.module.scss";
import { SingleInput } from "./singleInput";
import { useLanguageTranslator } from "hooks/use-language-translator";
export const CardOfInputs = ({
  list,
  totalFormData,
  setTotalFormData,
  handleUpdateCase,
  removeBg,
  dropdownsListObj,
  refetchDropdownsListObj,
  updateCaseLoading,
  caseHistoryUpdateLoading,
  variant,
  clickedItem,
}) => {
  const { translator } = useLanguageTranslator();

  return (
    <div
      className={styles.cardContainer}
      style={{
        backgroundColor: removeBg ? "transparent" : "#EBEEF480",
        border: removeBg ? "none" : "1px solid rgba(197, 210, 231, 0.4)",
      }}
    >
      <div
        className={
          variant === "section"
            ? styles.listOfInputsInSectionsLayout
            : styles.listOfInputs
        }
      >
        {list?.map((item) => (
          <SingleInput
            key={item.key}
            item={item}
            totalFormData={totalFormData}
            setTotalFormData={setTotalFormData}
            handleUpdateCase={handleUpdateCase}
            dropdownsListObj={dropdownsListObj}
            refetchDropdownsListObj={refetchDropdownsListObj}
            updateCaseLoading={updateCaseLoading}
            caseHistoryUpdateLoading={caseHistoryUpdateLoading}
            clickedItem={clickedItem}
          />
        ))}
      </div>
    </div>
  );
};
